import styled from '@emotion/styled';
import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import theme from '../../../styles/theme';
import useClickAway from '../../../hooks/useClickAway';

const BackgroundDim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 8px;
  background-color: white;
  box-shadow: ${theme.surface.boxShadow};
  border-radius: ${theme.surface.borderRadius};
  box-sizing: border-box;
  padding: ${theme.spacing.xl} ${theme.spacing.l};
  text-align: center;

  ${theme.mediaQuery('tablet')} {
    display: flex;
    width: 85%;
  }
`;

const Modal = ({ children, width, height, visible, onClose, ...props }) => {
  const ref = useClickAway(() => {
    onClose();
  });

  const containerStyle = useMemo(() => {
    return {
      width,
      height,
    };
  }, [width, height]);
  const el = useMemo(() => document.createElement('div'), []);

  useEffect(() => {
    document.body.appendChild(el);
    return () => {
      document.body.removeChild(el);
    };
  }, [el]);

  return ReactDOM.createPortal(
    <BackgroundDim style={{ display: visible ? 'block' : 'none' }}>
      <ModalContainer ref={ref}>
        <div style={{ ...props.style, ...containerStyle }}>{children}</div>
      </ModalContainer>
    </BackgroundDim>,
    el,
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  style: PropTypes.object,
};

Modal.defaultProps = {
  width: 500,
  visible: false,
  onClose: () => {},
};

export default Modal;
